import React from 'react';

import Grid from '@mui/material/Grid2';

import { 
  GreaterAdvantage
} from "@dndModels";
import { 
  ABILITY_SCORES,
  ROLL_TYPES
} from "@dndModels/Constants";
import { 
  AbilityScoreType,
  RollType
} from "@dndModels/Types";

import SelectStringBox from "@components/input/selects/SelectStringBox";

interface Props {
  obj: GreaterAdvantage;
  onChange: (changed: GreaterAdvantage) => void; 
  disabled: boolean;
}

export default function GreaterAdvantageInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>Rolling an Extra Die as part of Advantage will happen for certain situations.</Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox
          name="Roll Types" 
          options={ROLL_TYPES}
          values={obj.roll_types} 
          disabled={disabled}
          multiple
          onChange={(changed: RollType[]) => {
            const new_obj = obj;
            new_obj.roll_types = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
      <Grid
        size={{
          xs: 6
        }}>
        <SelectStringBox
          name="Ability Scores" 
          options={ABILITY_SCORES}
          values={obj.use_ability_scores} 
          disabled={disabled}
          multiple
          onChange={(changed: AbilityScoreType[]) => {
            const new_obj = obj;
            new_obj.use_ability_scores = changed;
            onChange(new_obj);
          }} 
        />
      </Grid>
    </Grid>
  );
}
